import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css
import { DateRange } from 'react-date-range';
import { RoundedButton } from '@codametrix/ui-components';
import './datepicker.scss';
const defaultRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
    showDateDisplay: false
};
export class DatePicker extends React.Component {
    handleSelect(ranges, clear = false) {
        this.setState({
            ranges: [
                ranges.selection
            ]
        });
        const customEvent = new CustomEvent('change', {
            detail: {
                value: {
                    range: [
                        ranges.selection
                    ],
                    clear,
                    dateOption: this.state.dateOption
                }
            }
        });
        this.props.onSelection(customEvent);
    }
    _onDateOptionSelect(e) {
        const target = e.target;
        const index = target.selectedIndex;
        var optionElement = e.target.childNodes[index];
        var optionId = optionElement.getAttribute('id');
        if (optionId) {
            this.setState({
                dateOption: optionId
            });
        }
        const customEvent = new CustomEvent('change', {
            detail: {
                value: {
                    range: this.state.ranges,
                    clear: false,
                    dateOption: optionId
                }
            }
        });
        this.props.onSelection(customEvent);
    }
    render() {
        const { options } = this.props;
        var dateOptions;
        if (options) {
            dateOptions = options.map((option)=>{
                return /*#__PURE__*/ _jsxs("option", {
                    id: option.id,
                    selected: option.isSelected,
                    children: [
                        ' ',
                        option.name
                    ]
                }, option.id);
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "calendar-container",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "calendar-options",
                    children: [
                        options ? /*#__PURE__*/ _jsx("select", {
                            className: "form-select qa-date-form-select",
                            onChange: (e)=>{
                                this._onDateOptionSelect(e);
                            },
                            children: dateOptions
                        }) : null,
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                marginRight: '5px'
                            }
                        }),
                        /*#__PURE__*/ _jsx(RoundedButton, {
                            className: 'btn-secondary qa-date-filter-cancel',
                            onClick: ()=>{
                                this.handleSelect({
                                    selection: defaultRange
                                }, true);
                            },
                            children: "Clear"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DateRange, {
                    editableDateInputs: true,
                    moveRangeOnFirstSelection: false,
                    ranges: this.state.ranges,
                    onChange: this.handleSelect
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const dateOption = props.options?.find((option)=>{
            return option.isSelected;
        });
        this.state = {
            ranges: [
                {
                    startDate: props.startDate ? props.startDate : new Date(),
                    endDate: props.endDate ? props.endDate : new Date(),
                    key: 'selection',
                    showDateDisplay: false
                }
            ],
            dateOption: dateOption?.id ?? 'date_of_service'
        };
        this.handleSelect = this.handleSelect.bind(this);
    }
}
